<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <b-form-select v-model="selected" :options="period" class="w-100" />
          </b-col>

          <!-- Preview Payroll Button -->
          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <b-button
              variant="primary"
              class="w-100 d-flex justify-content-center align-items-center"
              @click="previewPayroll"
            >
              Preview
            </b-button>
          </b-col>

          <!-- Process Payroll Button -->
          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <b-button
              variant="primary"
              class="w-100 d-flex justify-content-center align-items-center"
              @click="processPayroll"
            >
              Process
            </b-button>
          </b-col>

          <!-- Export button -->
          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <b-button
              variant="primary"
              class="w-100 d-flex justify-content-center align-items-center"
              @click="exportPayroll"
            >
              Export
            </b-button>
          </b-col>

          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <b-button
              v-if="HasPermission(PermissionList.HRMS_Create)"
              variant="primary"
              :to="{
                path: '/hrmanagement/report',
              }"
              class="w-100 d-flex justify-content-center align-items-center"
            >
              <feather-icon icon="View" class="mr-50" />
              Variance Report
            </b-button>
          </b-col>

          <b-col
            cols="12"
            sm="2"
            class="d-flex flex-column justify-content-start align-items-start mb-2"
          >
            <!-- Add Allocation Button -->
            <b-button
              v-if="HasPermission(PermissionList.HRMS_Create)"
              variant="primary"
              :to="{
                path: '/hrmanagement/Allocations/AddAllocation/add-allocation',
              }"
              class="d-none d-md-flex justify-content-end align-items-center"
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Allocation
            </b-button>
            <b-button
              v-if="HasPermission(PermissionList.HRMS_Create)"
              variant="primary"
              :to="{
                path: '/hrmanagement/Allocations/AddAllocation/add-allocation',
              }"
              class="d-flex d-md-none w-100 justify-content-center align-items-center"
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Allocation
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="2" sm="1" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            class="d-flex justify-content-end mb-2"
            style="position: relative; z-index: 1"
          >
            <!-- <b-button
              v-if="HasPermission(PermissionList.HRMS_Search)"
              variant="outline-danger"
              @click="clearFilters"
            >
              Clear Filters
            </b-button> -->
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="filteredEmployees"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <!-- Filter inputs for columns -->
              <!-- <template #head(firstName)="scope">
                <div class="d-flex flex-column">
                  <span> Name</span>
                  <b-form-input
                    v-model="filters.firstName"
                    placeholder="Filter by Name"
                    @input="currentPage = 1"
                    size="sm"
                  />
                </div>
              </template> -->

              <!-- <template #head(departmentName)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('departmentName')"
                    style="cursor: pointer"
                    >Department</span
                  >
                  <b-form-input
                    v-model="filters.departmentName"
                    placeholder="Filter by Department"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(designationName)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('designationName')"
                    style="cursor: pointer"
                    >Designation</span
                  >
                  <b-form-input
                    v-model="filters.designationName"
                    placeholder="Filter by Designation"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(email)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('email')" style="cursor: pointer"
                    >Email</span
                  >
                  <b-form-input
                    v-model="filters.email"
                    placeholder="Filter by Email"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(hireDate)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('hireDate')" style="cursor: pointer"
                    >Joining Date</span
                  >
                  <DatePicker
                    v-model="filters.hireDateRange"
                    range
                    format="YYYY-MM-DD"
                    placeholder="Select date range"
                    @change="applyFilters"
                    style="width: 100%"
                  />
                </div>
              </template> -->

              <!-- <template #cell(firstName)="data">
                {{ formatName(data.item) }}
              </template> -->

              <!-- <template #cell(hireDate)="data">
                {{ formatDate(data.item) }}
              </template> -->

              <!-- <template #cell(status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template> -->

              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <!-- {{ data }} -->
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    :to="{
                      name: 'payroll-view',
                      params: { id: data.item.id, allocationDate: selected },
                    }"
                    v-if="HasPermission(PermissionList.HRMS_View)"
                  >
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">View</span>
                  </b-dropdown-item>
                  <!-- <b-dropdown-item
                    :to="{
                      name: 'edit-employee',
                      params: { id: data.item.id },
                    }"
                    v-if="HasPermission(PermissionList.HRMS_Edit)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="HasPermission(PermissionList.HRMS_Delete)"
                    @click="removeEmployee(data.item.id)"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="modal-edit-leave-request"
              ok-only
              ok-title="Edit"
              centered
              size="lg"
              title="Edit Leave Request"
              :hide-footer="true"
              ref="editLeaveRequest"
            >
              <EditLeaveRequest @refresh="refreshData" />
            </b-modal>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
          <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BCardBody,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BCardBody,
    DatePicker,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      filter: null,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterOn: ["firstName"],
      filters: {
        firstName: "",
        lastName: "",
        Amount: "",
        email: "",
      },
      fields: [
        { key: "firstName", label: "First Name", sortable: true },
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "nic", label: "NIC", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      status: [
        {
          1: "Pending",
          2: "Approved",
          3: "Declined",
          4: "Cancelled",
        },
        {
          1: "light-secondary",
          2: "light-success",
          3: "light-danger",
          4: "Secondary",
        },
      ],
      payrollListing: [],
      period: [],
      selected: null,
      deleteLoader: null,
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    ...mapGetters("allocationModule", {
      payroll: "payroll",
      loading: "loading",
    }),
    filteredEmployees() {
      if (!this.payrollListing.length) return [];
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
console.log("perpage", this.perPage);
      const data2 = Object.values(
        this.payrollListing.reduce((acc, employee) => {
          if (employee != null) {
            const employeeId = employee.employeeId;

            // If the employeeId does not exist in the accumulator, initialize it
            if (!acc[employeeId]) {
              acc[employeeId] = {
                firstName: employee.employees.firstName,
                lastName: employee.employees.lastName,
                email: employee.employees.email,
                nic: employee.employees.nic,
                id: employeeId,
                amount: 0, // Initialize amount to 0
              };

            
            }
              // Add the current amount to the total amount for the employeeId
              acc[employeeId].amount +=
                employee.allocationType == 0
                  ? employee.amount
                  : employee.amount * -1;
          }

          return acc;
        }, {}) // Initial value is an empty object
      );
      this.totalRows = data2.length;
      console.log("dataaaaa", data2);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("slice", data2.slice(startIndex, endIndex));
      console.log("totalrows",  this.totalRows);
      return data2
    },
  },
  async mounted() {
    this.period = [
      ...this.getLast12Months().map((month, index) => {
        const [monthName, year] = month.split(" ");

        return {
          value: `${monthName} ${year}`,
          text: month,
        };
      }),
    ];

    this.selected = this.period[0].value;
    Swal.fire({
      title: "Fetching Data...",
      text: "Please wait while payroll data is loading.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      //const response = await this.getPayrollListAction(this.selected);
      const response = await this.getPayrollListAction({
        allocationDate: this.selected,
        employeeId: "",
      });
      this.payrollListing = response; // Set payroll data
      this.totalRows = response.length; // Ensure total row count is set
      this.currentPage = 1; // Reset to first page
      Swal.close();
    } catch (error) {
      console.error("Error fetching payroll:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch payroll data. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  },
  methods: {
    getLast12Months() {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      let last12Months = [];

      for (let i = 0; i < 12; i++) {
        let month = (currentMonth - i + 12) % 12;
        let year = currentYear - Math.ceil((i - currentMonth) / 12);
        last12Months.push(`${months[month]} ${year}`);
      }

      return last12Months;
    },
    refreshData() {},
    // onFiltered() {},
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "removeEmployeeAction",
    ]),

    ...mapActions("allocationModule", [
      "getPayrollListAction",
      "postPayrollAction",
      "exportPayrollAction",
    ]),

    async exportPayroll() {
      let datetime = "";
      let selecteddate = "";

      if (this.selected == null) {
        this.errorDate();
      } else {
        datetime = this.convertToDate(this.selected);
        selecteddate = this.formatDateToCustomString(datetime);
        // console.log("datetime", selecteddate);
      }

      this.$swal({
        title: "Downloading...",
        text: "Please wait while the file is being downloaded.",
        didOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: false,
      });

      try {
        await this.exportPayrollAction(selecteddate);
        this.$swal.close();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "There was a problem downloading the file.",
          footer: "Try again later",
        });
      }
    },

    async previewPayroll() {
      let datetime = "";
      let selecteddate = "";
      Swal.fire({
        title: "Fetching Data...",
        text: "Please wait while payroll data is loading.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      if (this.selected == null) {
        this.errorDate();
      } else {
        datetime = this.convertToDate(this.selected);
        selecteddate = this.formatDateToCustomString(datetime);
      }

      try {
        //const response = await this.getPayrollListAction(this.selected);
        const response = await this.getPayrollListAction({
          allocationDate: selecteddate,
          employeeId: "",
        });
        this.payrollListing = response; // Update the full payroll list
        this.totalRows = response.length; // Set the total rows for pagination
        Swal.close();
      } catch (error) {
        console.error("Error fetching payroll:", error);
        // Show error message if fetching fails
        Swal.fire({
          title: "Error",
          text: "Failed to fetch payroll data. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    successProcess() {
      this.$swal({
        title: "Processed!",
        text: "You have successfully processed your data!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    processPayroll() {
      let datetime = "";
      let selecteddate = "";
      // console.log("selectedDate", this.selected);

      Swal.fire({
        title: "Processing Data...",
        text: "Please wait while payroll data is processing.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      if (this.selected == null) {
        this.errorDate();
      } else {
        datetime = this.convertToDate(this.selected);
        selecteddate = this.formatDateToCustomString(datetime);
        // console.log("datetime", selecteddate);
      }

      //  this.postPayrollAction({ allocationDate: selecteddate });
      this.postPayrollAction({ allocationDate: selecteddate }).then(() => {
        Swal.close();
        this.successProcess();
        this.previewPayroll();
      });
    },

    convertToDate(monthYear) {
      const [monthName, year] = monthYear.split(" ");

      const monthMap = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      const month = monthMap[monthName];

      const date = new Date(year, month, 1);

      return date;
    },

    formatDateToCustomString(date) {
      if (!date) return "";
      return moment(date).format("YYYY-MM-DD");
    },

    errorDate() {
      this.$swal({
        title: "Error!",
        text: " Please select a payroll month!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    refreshData() {},
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    formatName: (employee) => `${employee.firstName} ${employee.lastName}`,
    formatDate: (employee) =>
      new Date(employee.hireDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
    removeEmployee(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteLoader = customLoader(
            "Please wait while employee is being removed"
          );
          this.removeEmployeeAction(id)
            .then((response) => {
              console.log(response);
              this.getPayrollListAction();
              this.deleteLoader.close();
              customSwal("Employee has been deleted", "Deleted!");
            })
            .catch((error) => {
              this.deleteLoader.close();
              customError(error.response.data, "Deless!");
              this.getPayrollListAction();
            });
        } else if (result.dismiss === "cancel") {
          customSwal("Employee not deleted", "Cancelled", "error");
        }
      });
    },
    applyFilters() {
      this.currentPage = 1;
    },
    clearFilters() {
      this.filters = {
        firstName: "",
        departmentName: "",
        designationName: "",
        email: "",
        hireDateRange: [null, null],
      };
      this.currentPage = 1;
    },
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },
  watch: {
    payrollListing(newVal) {
      if (newVal.length) {
        this.currentPage = 1; // Reset to page 1 when new data loads
        this.totalRows = newVal.length; // Update total rows
        //this.filteredEmployees();
      }
    },
    currentPage() {
      //this.filteredEmployees(); // Refresh when page changes
    },
  },
};
</script>
